import { ACCORDION_COMMON_TASKS, ACCORDION_SELECT_TASKS } from './accordion-table.tasks';
import { TAccordionTableVM } from './accordion-table.types';

export const PIPELINE_ACCORDION_TABLE = {
  applyOptions: (accordionModel: TAccordionTableVM): TAccordionTableVM => {
    return [
      ACCORDION_SELECT_TASKS.addSelectFeature,
      ACCORDION_SELECT_TASKS.hideSingleSelectHeader,
      PIPELINE_ACCORDION_TABLE.updateAllSelectCells,
      ACCORDION_COMMON_TASKS.logAccordionModel,
    ].reduce((acc, v) => v(acc), accordionModel);
  },
  updateAllSelectCells: (accordionModel: TAccordionTableVM): TAccordionTableVM => {
    return [ACCORDION_SELECT_TASKS.updateAccordionSelect, ACCORDION_COMMON_TASKS.logAccordionModel].reduce(
      (acc, v) => v(acc),
      accordionModel,
    );
  },
};
